import styled from 'styled-components';

export const Section = styled.section`
  padding: ${({ theme }) => theme.spacing.xxl} ${({ theme }) => theme.spacing.xl};
  background: white;
`;

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${({ theme }) => theme.spacing.xxl};

  /* Tablet zone: 2 columns, the 3rd card spans both and is centered */
  @media (max-width: 1023px) and (min-width: 681px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  /* Mobile: single column */
  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto ${({ theme }) => theme.spacing.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
  color: white;
  font-weight: 300;
  transition: all 0.3s ease;
  position: relative;
  
  &::before {
    font-style: normal;
  }
`;

export const Icon = styled.img`
  width: 240px;
  height: 240px;
  max-width: 240px;
  margin-left: -80px;
  left: 0;
  right: 0;
  position: absolute;
`;

export const GridCard = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xxl};
  background: #fafafa;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    background: white;
  }
  
  &:hover ${IconContainer} {
    transform: scale(1.1);
  }
`;

export const CardTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  letter-spacing: 1px;
`;

export const CardDescription = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.6;
`;
